/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_LeadInputs */

const en_mk_parts_lead = /** @type {(inputs: Mk_Parts_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not four apps taped together. Issues, chat, agents and company memory sit on the same data — which is why an agent already knows what the team is working on without you re-explaining it.`)
};

const id_mk_parts_lead = /** @type {(inputs: Mk_Parts_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan empat aplikasi yang ditempel. Issue, obrolan, agen, dan ingatan perusahaan duduk di atas data yang sama — itulah sebabnya agen tahu apa yang sedang dikerjakan tim tanpa Anda menjelaskannya ulang.`)
};

/**
* | output |
* | --- |
* | "Not four apps taped together. Issues, chat, agents and company memory sit on the same data — which is why an agent already knows what the team is working on ..." |
*
* @param {Mk_Parts_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_lead = /** @type {((inputs?: Mk_Parts_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_lead(inputs)
	return en_mk_parts_lead(inputs)
});